module.exports = __webpack_public_path__ + "audio-98bc8fdf7d48.m4a";